import React from 'react';
import './Testimonial.scss';
import SectionTitle from '../../../../components/SectionTitle/SectionTitle';
import {preventOrphans} from '../../../../helpers';

const Testimonial = () => {
    const processedDescription = preventOrphans('Państwa zdanie jest dla nas na wagę złota. Zachęcamy do wyrażenia swojej opinii o naszym centrum zdrowia. Będziemy dokładać wszelkich starań by udoskonalać jakość świadczonych przez nas usług. Jesteśmy tu dla naszych Pacjentów.');

    return (
        <section className='testimonail-section section-common section-m'  data-aos="fade-up" data-aos-duration="1000">
            <div className="container">
                <div className="row">
                    <div className="testimonial-title-container section-p">
                <SectionTitle  title="Opinie pacjentów" />
                <p className='section-title-text'>
                {processedDescription}
            </p>
            </div>
                </div>
                <div className="section-p">
                <div className="elfsight-app-133f39c8-0ad2-41c1-9e3d-76bbb218ee89" data-elfsight-app-lazy></div>
                </div>
            </div>
        </section>
    );
};

export default Testimonial;